<template>
  <nav aria-label="Breadcrumb">
    <ol vocab="http://schema.org/" typeof="BreadcrumbList">
      <li property="itemListElement" typeof="ListItem">
        <a property="item" typeof="WebPage" href="/">
          <span property="name">Home</span>
        </a>
        <meta property="position" content="1" />
      </li>
      <li
        v-for="(crumb, index) in crumbs"
        :key="index"
        property="itemListElement"
        typeof="ListItem"
      >
        <template v-if="index + 1 < crumbsLength">
          <component
            :is="linkComponent"
            v-if="linkComponent === 'SmartLink'"
            :native="crumb.native !== false"
            :to="crumb.path"
            property="item"
            typeof="WebPage"
          >
            <span property="name">{{ crumb.name }}</span>
          </component>
          <a v-else property="item" typeof="WebPage" :href="crumb.path">
            <span property="name">{{ crumb.name }}</span>
          </a>
          <meta property="position" :content="index + 1" />
        </template>
        <span v-else property="name" aria-current="page">{{ crumb.name }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    crumbs: {
      type: Array,
      default: () => []
    },
    linkComponent: {
      type: String,
      default: null
    }
  },
  computed: {
    crumbsLength() {
      return this.crumbs.length
    }
  }
}
</script>

<style lang="scss" scoped>
ol {
  list-style: none;
}
li {
  display: inline;
  font-size: 11px;

  a {
    color: $black;

    &:hover {
      color: $grey-darker;
      text-decoration: underline;
    }
  }

  &:after {
    color: $grey-darker;
    content: '/';
    display: inline;

    padding: 0 3px;
  }

  &:last-of-type {
    a {
      color: $grey-darker;
      cursor: default;
      pointer-events: none;
    }

    &:after {
      content: '';
    }
  }
}
</style>
